import { useAtomCallback as useBaseAtomCallback } from '@exodus/jotai/utils';
import { useCallback } from 'react';
export function useAtomCallback(callback, dependencies) {
    return useBaseAtomCallback(useCallback(callback, dependencies));
}
